import {Button} from '@ui/shadcn/button';
import type {NotificationChannelMeta} from '@ui/local/notification-channels';

interface ChannelRowProps {
  /** Канал строки — иконка, имя и фирменный цвет берутся отсюда. */
  channel: NotificationChannelMeta;
  connected: boolean;
  onConnect: () => void;
  onDisconnect: () => void;
}

/** Строка канала уведомлений с кнопкой подключения/отключения. */
export const ChannelRow = ({
  channel,
  connected,
  onConnect,
  onDisconnect,
}: ChannelRowProps) => {
  return (
    <div className='flex min-w-0 flex-wrap items-center justify-between gap-2 py-2.5'>
      <div className='flex min-w-0 items-center gap-2.5'>
        <span
          className='w-8 h-8 rounded-lg flex items-center justify-center'
          style={{
            backgroundColor: 'var(--color-muted)',
            color: channel.brandColor,
          }}
        >
          {channel.icon(16)}
        </span>
        <div className='min-w-0'>
          <span className='text-sm font-medium'>{channel.label}</span>
          <p className='text-[11px] text-[var(--color-muted-foreground)]'>
            {connected ? 'Подключён' : 'Не подключён'}
          </p>
        </div>
      </div>
      {connected ? (
        <Button
          type='button'
          variant='outline'
          size='xs'
          onClick={onDisconnect}
        >
          Отключить
        </Button>
      ) : (
        <Button
          type='button'
          variant='default'
          size='xs'
          onClick={onConnect}
          className='text-xs'
        >
          Подключить
        </Button>
      )}
    </div>
  );
};
